import { Component, Input, OnInit } from '@angular/core';

import { ApiError, BaseFormList, MessageService } from '../../../core';

import { UsuarioMarca } from './usuario-marca';
import { ItemMarca, ItemMarcaCrudHttpService } from '../../item-marca';

@Component({
    selector: 'sgt-usuario-marca',
    templateUrl: './usuario-marca.component.html',
    styleUrls: ['./usuario-marca.component.less']
})
export class UsuarioMarcaComponent implements BaseFormList<UsuarioMarca>, OnInit {
    @Input() entities: UsuarioMarca[];
    marcas: ItemMarca[];

    constructor(private messageService: MessageService,
                private itemMarcaCrudHttpService: ItemMarcaCrudHttpService) { }

    ngOnInit() {
        this.searchMarcas();
    }

    /** Pesquisa as marcas cadastradas */
    private searchMarcas() {
        this.marcas = [];
        this.itemMarcaCrudHttpService.search()
            .subscribe(
                entities => this.marcas = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as marcas', error)
            );
    }

    /** Ao alterar a marca */
    onChangeMarca(entity: UsuarioMarca, idItemMarca: number) {
        entity.idItemMarca = idItemMarca;
        if (idItemMarca) {
            entity.itemMarca = this.marcas.find(marcaFilter => marcaFilter.id === idItemMarca);
        } else {
            entity.itemMarca = null;
        }
    }

    insert() {
        const entity = new UsuarioMarca();
        this.entities.push(entity);
    }

    delete(index: number) {
        const entity = this.entities[index];
        this.messageService.confirm(`Deseja realmente excluir a marca ${(entity && entity.itemMarca) ? entity.itemMarca.nome : ''} do usuário?`).then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Verifica se as marcas do Usuario estão válidas */
    isValid(): boolean {
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];


            const count = this.entities.filter(entityFilter => entityFilter.idItemMarca && entityFilter.idItemMarca === entity.idItemMarca).length;
            const nomeMarca = (entity && entity.itemMarca) ? entity.itemMarca.nome : ''
            if (count > 1) {
                this.messageService.info(`A marca ${nomeMarca} já está adicionada. Remova ou altere a marca duplicada`, 'Não é possível adicionar duas marcas iguais');
                return false;
            }
        }

        return true;
    }

    /** Resolve as marcas do Usuario */
    resolve() {
        for (let i = this.entities.length; i--; ) {
            const entity = this.entities[i];
            if (!entity.idItemMarca) {
                this.entities.splice(i, 1);
            }
        }
    }

    /** Adiciona todas as marcas cadastradas ao Usuario */
    adicionarTodasMarcas() {
        if (!this.marcas) {
            return;
        }

        for (let i = 0; i < this.marcas.length; i++) {
            const marca = this.marcas[i];

            // Somente adiciona quando a marca ainda não estiver adicionada
            const index = this.entities.findIndex(marcaFilter => marcaFilter.idItemMarca === marca.id);
            if (index === -1) {
                const entity = new UsuarioMarca();
                entity.idItemMarca = marca.id;
                entity.itemMarca = marca;
                this.entities.push(entity);
            }
        }
    }
}
